require.register("export/controllers/rdfCtrl", function(exports, require, module){
  $0
  
});

